<template>
  <v-card raised>
    <v-card-text>
      <router-view /> 
    </v-card-text>
  </v-card>
</template>
<script>
import { mapGetters } from 'vuex'

export default {
  // retrieves response info
  mounted: function() {
    this.$store.dispatch('bindResponseRef', this.$route.params.questions)
  },
  validate({ params }) {
    // Must exist in the database
    return /^[a-zA-Z0-9]+$/.test(params.questions);
  }
};
</script>
